export const CUSTOMER_DOC_FOLDERS = [
  { id: "Contract", value: "Contract", label: "Contract" },
  { id: "KYC", value: "KYC", label: "Manual" },
  { id: "NDA", value: "NDA", label: "Other" },
  { id: "Tendencias", value: "Tendencias", label: "Tendencias" },
];

export const UNASSIGNED_SEASON = "__sin_temporada__";

const TENDENCIAS_ENCODED = /^Tendencias[|:\/](.+)$/i;

export const getFolderById = (folderId) =>
  CUSTOMER_DOC_FOLDERS.find((folder) => folder.id === folderId) || null;

export const normalizeSeasonLabel = (value) => String(value || "").trim();

export const encodeTendenciasTipo = (temporada) => {
  const season = normalizeSeasonLabel(temporada);
  return season ? `Tendencias|${season}` : "Tendencias";
};

export const parseCustomerDocType = (tipoDocumento) => {
  const raw = String(tipoDocumento || "").trim();
  if (!raw) return { folderId: "NDA", temporada: "" };

  const encoded = raw.match(TENDENCIAS_ENCODED);
  if (encoded) {
    return { folderId: "Tendencias", temporada: normalizeSeasonLabel(encoded[1]) };
  }
  if (/^tendencias$/i.test(raw)) {
    return { folderId: "Tendencias", temporada: "" };
  }
  if (/^contract$/i.test(raw)) return { folderId: "Contract", temporada: "" };
  if (/^(kyc|manual)$/i.test(raw)) return { folderId: "KYC", temporada: "" };
  return { folderId: "NDA", temporada: "" };
};

export const getDocFolderId = (doc) => parseCustomerDocType(doc?.TipoDocumento).folderId;

export const getDocTemporada = (doc) => {
  const fromColumn = normalizeSeasonLabel(doc?.Temporada);
  if (fromColumn) return fromColumn;
  return parseCustomerDocType(doc?.TipoDocumento).temporada;
};

export const docsInFolder = (documentos, folderId) =>
  (Array.isArray(documentos) ? documentos : []).filter(
    (doc) => getDocFolderId(doc) === folderId,
  );

export const docsInSeason = (documentos, temporada) => {
  const docs = docsInFolder(documentos, "Tendencias");
  if (temporada === UNASSIGNED_SEASON) {
    return docs.filter((doc) => !getDocTemporada(doc));
  }
  const wanted = normalizeSeasonLabel(temporada).toLowerCase();
  return docs.filter(
    (doc) => getDocTemporada(doc).toLowerCase() === wanted,
  );
};

export const countByFolder = (documentos) =>
  CUSTOMER_DOC_FOLDERS.reduce((acc, folder) => {
    acc[folder.id] = docsInFolder(documentos, folder.id).length;
    return acc;
  }, {});

export const getTemporadaLabel = (row) =>
  normalizeSeasonLabel(row?.TEMPORADA || row?.Temporada || row?.ABREVIATURA);

export const uniqueSeasonFolders = (documentos, temporadas = []) => {
  const counts = new Map();
  docsInFolder(documentos, "Tendencias").forEach((doc) => {
    const season = getDocTemporada(doc) || UNASSIGNED_SEASON;
    counts.set(season, (counts.get(season) || 0) + 1);
  });

  const labels = new Map();
  (Array.isArray(temporadas) ? temporadas : []).forEach((row) => {
    const label = getTemporadaLabel(row);
    if (label) labels.set(label.toLowerCase(), label);
  });

  const seasons = [];
  counts.forEach((count, key) => {
    if (key === UNASSIGNED_SEASON) {
      seasons.push({
        id: UNASSIGNED_SEASON,
        label: "Sin temporada",
        count,
        fromCatalog: false,
      });
      return;
    }
    seasons.push({
      id: key,
      label: labels.get(key.toLowerCase()) || key,
      count,
      fromCatalog: labels.has(key.toLowerCase()),
    });
  });

  return seasons;
};

export const catalogSeasonsNotInFolders = (temporadas = [], folders = []) => {
  const existing = new Set(
    (folders || [])
      .map((folder) => String(folder.id || "").trim().toLowerCase())
      .filter((id) => id && id !== UNASSIGNED_SEASON),
  );
  const seen = new Set();
  return (Array.isArray(temporadas) ? temporadas : [])
    .map((row) => getTemporadaLabel(row))
    .filter(Boolean)
    .filter((label) => {
      const key = label.toLowerCase();
      if (seen.has(key) || existing.has(key)) return false;
      seen.add(key);
      return true;
    });
};
